// Export the Component Definition for use in Contentful Studio
export {HeadingContentfulComponentDefinition} from './HeadingContentfulDefinition';
export {default} from './Heading';
